import { render, staticRenderFns } from "./FormEditPost.vue?vue&type=template&id=a13beb2a&scoped=true"
import script from "./FormEditPost.vue?vue&type=script&lang=js"
export * from "./FormEditPost.vue?vue&type=script&lang=js"
import style0 from "./FormEditPost.vue?vue&type=style&index=0&id=a13beb2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13beb2a",
  null
  
)

export default component.exports